import {
    AGE_LIMITS,
    MONTHS,
    VALIDATION_MESSAGES,
} from "../../../../constants/progressBanner"
import {
    HandleKeyDownFunction,
    HandleNumericInputFunction,
    ValidateMessageSetter,
    ValidationResult,
} from "./types"

export const handleKeyDown: HandleKeyDownFunction = e => {
    const allowedKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "Tab",
        "Enter",
    ]

    if (
        !/^\d$/.test(e.key) &&
        !allowedKeys.includes(e.key) &&
        !e.ctrlKey &&
        !e.metaKey
    ) {
        e.preventDefault()
    }
}

export const handleNumericInput: HandleNumericInputFunction = (
    value,
    setValue
) => {
    const numericValue = value.replace(/[^0-9]/g, "")
    setValue(numericValue)
}

const validateYearMonth = (year: string, month: string): ValidationResult => {
    if (!year || !month) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.INVALID_VALUE,
        }
    }

    if (isNaN(Number(year)) || isNaN(Number(month))) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.INVALID_NUMBER,
        }
    }

    const monthNum = parseInt(month, 10)
    if (monthNum < MONTHS.MIN || monthNum > MONTHS.MAX) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.INVALID_MONTH_RANGE,
        }
    }

    return {
        isValid: true,
        message: "",
    }
}

const validateFutureDate = (
    yearNum: number,
    monthNum: number,
    currentDate: string
): ValidationResult => {
    const [currentYear, currentMonth] = currentDate.split("-").map(Number)

    if (
        yearNum > currentYear ||
        (yearNum === currentYear && monthNum > currentMonth)
    ) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.INVALID_DATE,
        }
    }

    return {
        isValid: true,
        message: "",
    }
}

const validateAge = (
    yearNum: number,
    currentYear: number
): ValidationResult => {
    const userAge = currentYear - yearNum

    if (userAge < AGE_LIMITS.MIN) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.AGE_TOO_YOUNG,
        }
    }

    if (userAge > AGE_LIMITS.MAX) {
        return {
            isValid: false,
            message: VALIDATION_MESSAGES.AGE_TOO_OLD,
        }
    }

    return {
        isValid: true,
        message: "",
    }
}

export const validateDate = (
    year: string,
    month: string,
    currentDate: string,
    setValidateMessage: ValidateMessageSetter
): boolean => {
    if (!currentDate) return false

    const yearMonthResult = validateYearMonth(year, month)
    if (!yearMonthResult.isValid) {
        setValidateMessage(yearMonthResult.message)
        return false
    }

    const yearNum = parseInt(year, 10)
    const monthNum = parseInt(month, 10)

    const futureDateResult = validateFutureDate(yearNum, monthNum, currentDate)
    if (!futureDateResult.isValid) {
        setValidateMessage(futureDateResult.message)
        return false
    }

    const [currentYear] = currentDate.split("-").map(Number)
    const ageResult = validateAge(yearNum, currentYear)
    if (!ageResult.isValid) {
        setValidateMessage(ageResult.message)
        return false
    }

    setValidateMessage("")
    return true
}
